import React from "react";
import {
  useOtherTextResponse,
  useDrilledDownResponse,
} from "screens/question/hooks";
import {
  Container,
  Wrapper,
  Title,
  CheckBoxWrapper,
  CheckboxOuterContainer,
  Checkbox,
  CheckMarkImage,
  Label,
  SubOptionContainer,
  OtherTextWrapper,
} from "./styled";
import { TextInputWithMedia } from "screens/question/themeB/types/text-input";

export const DrilledDownQuestion = ({ question }) => {
  const {
    options,
    selectedOptions,
    selectSubOption,
    singleSelect,
    RTL,
  } = useDrilledDownResponse(question);
  return (
    <Container $RTL={RTL}>
      {options.map(option => {
        const selectedOption = selectedOptions[option.virtual_id] || {};
        return (
          <Wrapper key={option.id}>
            <Title $RTL={RTL}>{option.text}</Title>
            <CheckBoxWrapper>
              {option.sub_options.map(subOption => {
                const selectedSubOptions = selectedOption.subOptions || {};
                const isSelected = selectedSubOptions[subOption.virtual_id];
                return (
                  <SubOptionContainer key={subOption.id}>
                    <CheckboxOuterContainer
                      $RTL={RTL}
                      $isSelected={isSelected}
                      onPress={() => selectSubOption(option, subOption)}
                    >
                      <Checkbox
                        $isSelected={isSelected}
                        $singleSelect={singleSelect}
                      >
                        <CheckMarkImage
                          source={require("../../../../../assets/images/check-mark.png")}
                          $isSelected={isSelected}
                        />
                      </Checkbox>
                      <Label $RTL={RTL} $isSelected={isSelected}>
                        {subOption.text}
                      </Label>
                    </CheckboxOuterContainer>
                    {isSelected && subOption.is_other && (
                      <OtherText
                        option={option}
                        question={question}
                        subOption={subOption}
                      />
                    )}
                  </SubOptionContainer>
                );
              })}
            </CheckBoxWrapper>
          </Wrapper>
        );
      })}
    </Container>
  );
};

const OtherText = ({ question, option, subOption }) => {
  const { value, placeholder, onChange } = useOtherTextResponse(
    question,
    option,
    subOption,
  );
  return (
    <OtherTextWrapper>
      <TextInputWithMedia
        value={value}
        $fontSize={12}
        multiline={true}
        numberOfLines={3}
        onChangeText={onChange}
        placeholder={placeholder}
        question={question}
        option={option}
        subOption={subOption}
      />
    </OtherTextWrapper>
  );
};
